(function () {
  var config = window.PROMO_GIFT_CONFIG;
  if (!config || !config.active) return;

  function isDealLive(deal) {
    if (!deal || deal.active !== true) return false;
    var now = new Date();
    if (deal.startsAt) {
      var startsAt = new Date(deal.startsAt);
      if (!isNaN(startsAt.getTime()) && now < startsAt) return false;
    }
    if (deal.endsAt) {
      var endsAt = new Date(deal.endsAt);
      if (!isNaN(endsAt.getTime()) && now > endsAt) return false;
    }
    return true;
  }

  var singleRewardDeals = (config.deals || []).filter(function (d) {
    return isDealLive(d) && d.offerType === 'SINGLE_REWARD' &&
           d.rewardOptions && d.rewardOptions[0] && d.rewardOptions[0].discountType === 'FREE';
  });
  if (!singleRewardDeals.length) return;

  function isGiftLine(item) {
    return !!(item.properties && item.properties._promo_deal_number);
  }

  // One gift per qualifying unit. Gift lines never count, so a free gift can't unlock another.
  function qualifyingQuantity(items, deal) {
    return items.reduce(function (total, item) {
      if (isGiftLine(item)) return total;
      var qualifies = deal.qualifyingProductIds.indexOf(item.product_id) !== -1 ||
                      deal.qualifyingVariantIds.indexOf(item.variant_id) !== -1;
      return qualifies ? total + item.quantity : total;
    }, 0);
  }

  // Gifts count toward the deal they were added for, since several deals can share a reward.
  function rewardQuantity(items, deal) {
    return items.reduce(function (total, item) {
      return isGiftLine(item) && item.properties._promo_deal_number === String(deal.dealNumber)
        ? total + item.quantity
        : total;
    }, 0);
  }

  function addReward(deal, quantity) {
    var reward = deal.rewardOptions[0];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: reward.variantId,
          quantity: quantity,
          properties: {
            _promo_campaign: config.campaignName,
            _promo_deal_number: String(deal.dealNumber),
            _promo_reward_number: String(reward.rewardNumber)
          }
        }]
      })
    }).then(function (r) { return r.json(); });
  }

  // Lowers the deal's gift line by `excess`.
  function reduceReward(items, deal, excess) {
    var lineIndex = -1;
    items.forEach(function (item, i) {
      if (isGiftLine(item) && item.properties._promo_deal_number === String(deal.dealNumber)) lineIndex = i;
    });
    if (lineIndex === -1) return Promise.resolve();
    var newQuantity = Math.max(items[lineIndex].quantity - excess, 0);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex + 1, quantity: newQuantity })
    }).then(function (r) { return r.json(); });
  }

  function refreshCartDrawer() {
    var cart = document.querySelector('cart-drawer');
    if (!cart) return;
    var sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    fetch(window.location.pathname + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) { cart.renderContents({ sections: data }); })
      .catch(function (err) { console.error('[cart-promo-gift] drawer refresh failed:', err); });
  }

  function syncAllDeals() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items;
        // Sequential: each change shifts line numbers, so re-read the cart between deals.
        return singleRewardDeals.reduce(function (chain, deal) {
          return chain.then(function (current) {
            var difference = qualifyingQuantity(current, deal) - rewardQuantity(current, deal);
            var op = Promise.resolve();
            if (difference > 0) op = addReward(deal, difference);
            if (difference < 0) op = reduceReward(current, deal, -difference);
            return op
              .then(function () { return fetch('/cart.js'); })
              .then(function (r) { return r.json(); })
              .then(function (updated) { return updated.items; });
          });
        }, Promise.resolve(items));
      })
      .then(refreshCartDrawer)
      .catch(function (err) { console.error('[cart-promo-gift]', err); });
  }

  function onCartUpdate(event) {
    // Quantity changes in the cart change how many gifts are earned, not just adds.
    if (!event || (event.source !== 'product-form' && event.source !== 'cart-items')) return;
    syncAllDeals();
  }

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
